/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  Form,
  Row,
  Tabs,
  Col,
  Spin,
  Card,
  TreeSelect,
  Input,
  Menu,
  message,
  DatePicker,
} from 'antd';
import {
  AccountBookOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  RedoOutlined,
  SearchOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import ReporteRecurrenteModal, { FORMATO_MONEDA } from 'components/ReporteRecurrenteModal';
import { formatReceivedValues } from 'utils/formatValues';
import { areaBuscar, normalizeData } from 'utils/normalizers';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import { getModelPermission, hasActionPermission } from 'utils/permission';
import PercentageInput from 'components/PercentageInput';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import CurrencyInput from 'components/CurrencyInput';
import CustomSearch from 'components/customSearch';
import ExportadorExcelPersonalizado from 'components/ExportadorExcelPersonalizado';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment';
import {
  getLiquidacionesEmpleados,
  getLiquidacionEmpleado,
  postLiquidacionEmpleado,
  patchLiquidacionEmpleado,
  deleteLiquidacionEmpleado,
  recalcularLiquidacionEmpleado,
} from 'api/nominas/liquidaciones/liquidacionesEmpleados';
import { checkToken } from 'api/utils';
import currencyFormatter from 'utils/currencyFormatter';

import { getSalariosMinimosGenerales } from 'api/nominas/catalogos/salariosMinimosGenerales';
import { getAdministracionDePlazas, getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { getPlazas, getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getDatoOperacionalDelEmpleado, getDatoOperacionalesDeEmpleados, getDatoOperacionalPorEmpleado } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getTiposDeEmpleados } from 'api/catalogos/tiposDeEmpleados';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getMotivosDeLiquidaciones } from 'api/catalogos/motivosDeLiquidaciones';
import { getLiquidaciones } from 'api/nominas/liquidaciones/liquidaciones';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import {
  getEmpleadosConDatosOpFilteredPaginated, getEmpleadosFiltered, getEmpleadosOptimized, getEmpleadosWithoutFilter,
} from 'api/estructuraOrganizacional/empleados';
import { getAreas, getEstadosGlobales } from 'api/catalogos/index';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import {
  ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_CANCELADO, ESTATUS_INACTIVO,
} from 'utils/constants';

// Importacion de componentes
import LiquidacionesEmpleadosFiniquito, { liquidacionEmpleadoFiniquitoPermission } from 'views/Configuracion/Accesos/LiquidacionesEmpleados/LiquidacionesEmpleadosFiniquito';
import LiquidacionesEmpleadosIndemnizacion, { liquidacionEmpleadoIndemnizacionPermission } from 'views/Configuracion/Accesos/LiquidacionesEmpleados/LiquidacionesEmpleadosIndemnizacion';
import LiquidacionesEmpleadosDescuentos, { liquidacionEmpleadoDescuentoPermission } from 'views/Configuracion/Accesos/LiquidacionesEmpleados/LiquidacionesEmpleadosDescuentos';
import LiquidacionesEmpleadosDeducciones, { liquidacionEmpleadoDeduccionPermission } from 'views/Configuracion/Accesos/LiquidacionesEmpleados/LiquidacionesEmpleadosDeducciones';
import LiquidacionesEmpleadosAnexos, { liquidacionEmpleadoAnexoPermission } from 'views/Configuracion/Accesos/LiquidacionesEmpleados/LiquidacionesEmpleadosAnexos';
import { selectPeriodoFiscalSelected } from 'store/auth';
import { useSelector } from 'react-redux';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalAuthorize from 'components/ModalAuthorize';
import ModalPeriodoPagoLiquidacionEmpleado from './ModalPeriodoPagoLiquidacionEmpleado';

const { TabPane } = Tabs;

const TAB_ESTADOS_LIQUIDACIONES = {
  todas: null, activas: ESTATUS_ACTIVO, autorizadas: ESTATUS_AUTORIZADO, canceladas: ESTATUS_CANCELADO,
};

export const liquidacionEmpleadoPermission = {
  permissionModel: 'liquidacionempleado',
  catalogsModels: [],
  tabsModels: [],
};

const LiquidacionesEmpleados = ({ permission }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState();
  const [open, setVisible] = useState();
  const [visibleAlert, setVisibleAlert] = useState();
  const [visiblePeriodo, setVisiblePeriodo] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [form] = Form.useForm();
  const [formModal] = Form.useForm();
  const [empleados, setEmpleados] = useState([]);
  const [tiposDeEmpleados, setTiposDeEmpleados] = useState();
  const [periodosDeNominas, setPeriodosDeNominas] = useState();
  const [motivosLiquidaciones, setMotivosLiquidaciones] = useState();
  const [showReporteLiquidaciones, setShowReporteLiquidaciones] = useState(false);
  const [liquidaciones, setLiquidaciones] = useState();
  const [puestos, setPuestos] = useState();
  const periodoFiscalSelected = useSelector(selectPeriodoFiscalSelected);
  // const [datosOpEmp, setDatosOpEmp] = useState();
  const [plazas, setPlazas] = useState();
  const [areas, setAreas] = useState();
  const [administracionPlazas, setAdministracionPlazas] = useState();
  const [salariosMinimosGenerales, setSalariosMinimosGenerales] = useState();
  const [periodosDeNominaDetalles, setPeriodosDeNominaDetalles] = useState([]);
  const [periodosDetallesFiltered, setPeriodosDetallesFiltered] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState();
  const [liquidacionEmpleadoDelete, setLiquidacionEmpleadoDelete] = useState();
  const [liquidacionAplicaFiniquito, setLiquidacionAplicaFiniquito] = useState(false);
  const [liquidacionAplicaIndemnizacion, setLiquidacionAplicaIndemnizacion] = useState(false);
  const [liquidacionDescuentoEnable, setLiquidacionDescuentoEnable] = useState();
  const [liquidacionDeduccionEnable, setLiquidacionDeduccionEnable] = useState();
  const [liquidacionAnexoEnable, setLiquidacionAnexoEnable] = useState();
  const [liquidacionEmpleado, setLiquidacionEmpleado] = useState();
  const [importeNeto, setImporteNeto] = useState();
  const [estados, setEstados] = useState([]);
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [openSearch, setVisibleSearch] = useState(false);
  const [dataSearch, setDataSearch] = useState([]);
  const [baseURIPagination, setBaseURIPagination] = useState();
  const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleReactivar, setVisibleReactivar] = useState(false);
  const [tipoNominaEmpleadoId, setTipoNominaEmpleadoId] = useState(null);
  const [showExportador, setShowExportador] = useState(false);
  const [tabListaActiva, setTabListaActiva] = useState('todas');
  const [administracionesDePlaza, setAdministracionesDePlaza] = useState([]);
  // const [catalogosCargados, setCatalogosCargados] = useState(false);

  // let baseURIDatosOpPaginado = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=estado_del_empleado=3';

  const getPermissionLiquidacionEmpleadoFiniquito = getModelPermission(
    liquidacionEmpleadoFiniquitoPermission.permissionModel,
    liquidacionEmpleadoFiniquitoPermission.catalogsModels,
    liquidacionEmpleadoFiniquitoPermission.tabsModels,
    false,
  );

  const getPermissionLiquidacionEmpleadoIndemnizacion = getModelPermission(
    liquidacionEmpleadoIndemnizacionPermission.permissionModel,
    liquidacionEmpleadoIndemnizacionPermission.catalogsModels,
    liquidacionEmpleadoIndemnizacionPermission.tabsModels,
    false,
  );

  const getPermissionLiquidacionEmpleadoDescuento = getModelPermission(
    liquidacionEmpleadoDescuentoPermission.permissionModel,
    liquidacionEmpleadoDescuentoPermission.catalogsModels,
    liquidacionEmpleadoDescuentoPermission.tabsModels,
    false,
  );

  const getPermissionLiquidacionEmpleadoDeduccion = getModelPermission(
    liquidacionEmpleadoDeduccionPermission.permissionModel,
    liquidacionEmpleadoDeduccionPermission.catalogsModels,
    liquidacionEmpleadoDeduccionPermission.tabsModels,
    false,
  );

  const getPermissionLiquidacionEmpleadoAnexo = getModelPermission(
    liquidacionEmpleadoAnexoPermission.permissionModel,
    liquidacionEmpleadoAnexoPermission.catalogsModels,
    liquidacionEmpleadoAnexoPermission.tabsModels,
    false,
  );

  const formInstances = [
    form,
  ];

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        tipo_empleado: e?.empleado,
        puesto_empleado: e?.empleado,
        area_empleado: e?.empleado,
        numero_plaza_empleado: e?.empleado,
        fecha_ingreso: e?.empleado,
        fecha_baja: e?.empleado,
        antiguedad_empleado: e?.empleado,
        motivo_baja_empleado: e?.empleado,

      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const fetchData = async (tabKey = tabListaActiva) => {
    setLoading(true);
    const estadosGlobalesId = TAB_ESTADOS_LIQUIDACIONES[tabKey];
    const _data = await getLiquidacionesEmpleados(
      estadosGlobalesId ? { estados_globales_id: estadosGlobalesId } : undefined,
    );
    setData(formatReceivedClone(_data));
    setLoading(false);
  };

  const onChangeTabLista = (newTab) => {
    setTabListaActiva(newTab);
    setSelectedRowKeys([]);
    setSelectedData([]);
    fetchData(newTab);
  };

  // const cargarCatalogos = async () => {
  //   setLoading(true);
  //   await checkToken();

  //   const [
  //     // _datosOpEmp,
  //     _plazas,
  //     resEmpleados,
  //   ] = await Promise.all([
  //     // getDatoOperacionalesDeEmpleados(),
  //     getPlazasvistaOptimized(),
  //     getEmpleadosFiltered(),
  //   ]);
  //   setPlazas(_plazas);
  //   // setDatosOpEmp(_datosOpEmp);
  //   setEmpleados(resEmpleados);
  //   setLoading(false);
  // };

  // useEffect(() => {
  //   if (selectedEmpleadoSearch) {
  //     form.setFieldsValue({
  //       empleado: `${selectedEmpleadoSearch?.numero_de_empleado || ''} - ${selectedEmpleadoSearch?.nombre || ''} ${selectedEmpleadoSearch?.apellido_paterno || ''} ${selectedEmpleadoSearch?.apellido_materno || ''}`,
  //     });
  //   }
  // }, [selectedEmpleadoSearch]);

  useEffect(() => {
    let mounted = true;

    const fetchDataInicial = async () => {
      setLoading(true);
      await checkToken();

      const [
        _data,
        _periodos_de_Nominas,
        _motivos_de_liquidaciones,
        _liquidaciones,
        _periodosDeNominaDetalles,
        _periodosNominas,
        _periodosFiscales,
        _estados,
        _tipos_de_nominas_empleados,
        _plazas,
        resEmpleados,
      ] = await Promise.all([
        getLiquidacionesEmpleados(),
        getPeriodosDeNominas({ estados_globales: ESTATUS_AUTORIZADO }),
        getMotivosDeLiquidaciones({ estados_globales: ESTATUS_AUTORIZADO }),
        getLiquidaciones({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominasDetalles(),
        getPeriodosDeNominas(),
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getEstadosGlobales(),
        getTiposDeNominasEmpleados(),
        getPlazasvistaOptimized(),
        getEmpleadosFiltered(),
      ]);

      if (mounted) {
        setData(formatReceivedClone(_data));
        setPeriodosDeNominas(_periodos_de_Nominas);
        setMotivosLiquidaciones(_motivos_de_liquidaciones);
        setLiquidaciones(_liquidaciones);
        setPeriodosDeNominaDetalles(
          _periodosDeNominaDetalles.filter((p) => _periodosNominas.some((n) => n.id === p?.periodo_de_nomina)),
        );
        setPeriodosFiscales(_periodosFiscales);
        setEstados(_estados);
        setTiposDeNominaEmpleado(_tipos_de_nominas_empleados);
        setPlazas(_plazas);
        setEmpleados(resEmpleados);
        // setCatalogosCargados(true); // ¡Muy importante! ES UNA MENTIIIIRAAAAAAAAA
        setLoading(false);
      }
    };

    fetchDataInicial();

    return () => {
      mounted = false;
    };
  }, []);

  const onCancel = async () => {
    setLoading(true);
    await fetchData();
    setSelectedRowKeys([]);
    setSelectedData([]);
    setSelectedEmpleadoSearch();
    setVisibleAutorizar(false);
    setVisibleCancelar(false);
    setVisibleReactivar(false);
    setLiquidacionAplicaFiniquito(false);
    setLiquidacionAplicaIndemnizacion(false);
    setLiquidacionDescuentoEnable(false);
    setLiquidacionDeduccionEnable(false);
    setLiquidacionAnexoEnable(false);
    setImporteNeto();
    setTipoNominaEmpleadoId(null);
    setAdministracionesDePlaza([]);
    setVisible(false);
    setVisibleSearch(false);
    form.resetFields();
    setLoading(false);
  };

  const calcularAntiguedad = (fechaRegistro) => {
    const fechaDiferencia = Date.now() - fechaRegistro;
    const fechaNueva = new Date(fechaDiferencia);
    const fechaAnual = (fechaNueva.getUTCFullYear() - 1970);
    const fechaMes = (fechaNueva.getUTCMonth());
    if ((Math.sign(fechaAnual) === -1) || (Number.isNaN(fechaAnual))) {
      return 0;
    }
    return `${fechaAnual} ${(fechaAnual === 1 ? 'año' : 'años')} ${fechaMes} ${(fechaMes === 1 ? 'mes' : 'meses')}`;
  };

  // Trae TODAS las Administraciones de Plaza del empleado (la vigente/Autorizada y las
  // históricas/Desasignadas), excluyendo Canceladas — el backend (LiquidacionEmpleado.
  // administracion_de_plaza) exige elegir una siempre, no solo cuando falta Fecha de
  // Baja: es la fuente de snapshot (Puesto, Tipo de Contratación, Plaza, sueldos, etc.)
  // que create() congela en la Liquidación en vez de leer el estado en vivo del
  // empleado (ver regla "Snapshot histórico de campos cascadeados de Plaza" en
  // CLAUDE.md).
  const fetchAdministracionesDePlaza = async (empleadoId) => {
    if (!empleadoId) {
      setAdministracionesDePlaza([]);
      return;
    }
    const _administraciones = await getAdministracionDePlazasvistaOptimized({
      empleado_id: empleadoId,
    });
    setAdministracionesDePlaza(
      (Array.isArray(_administraciones) ? _administraciones : [])
        .filter((a) => a?.estado_global_id !== ESTATUS_CANCELADO),
    );
  };

  const aplicarAdministracionDePlaza = (administracionId) => {
    const administracion = administracionesDePlaza.find((a) => a.id === administracionId);
    if (!administracion) {
      return;
    }
    const tipoNomina = administracion?.tipo_nomina_empleado_id;
    setTipoNominaEmpleadoId(tipoNomina);

    form.resetFields(['periodo_fiscal', 'periodo_de_nomina_detalle']);
    setPeriodosDetallesFiltered([]);

    form.setFieldsValue({
      tipo_empleado: administracion?.tipo_de_empleado,
      tipo_nomina_empleado: administracion?.tipo_nomina_empleado,
      puesto: administracion?.puesto_clave_y_descripcion,
      tipo_de_contratacion: administracion?.tipo_de_contratacion_descripcion,
      motivo_baja: administracion?.motivo_desasignacion_concepto,
      unidad_responsable: administracion?.directorio_area_clave_y_nombre,
      plaza: administracion?.plaza_clave_y_descripcion,
      // El modelo LiquidacionEmpleado espera "fecha_de_baja" (no "fecha_baja") para
      // que create() la use como FechaDeBajaActual en calcular_PrimaVacacionalProp()/
      // calcular_AguinaldoProp() — ver fix en liquidaciones_empleados.py. Si la
      // Administración elegida es la vigente (sin fecha_baja), se limpia el campo.
      fecha_de_baja: administracion?.fecha_baja
        ? moment(administracion.fecha_baja) : null,
      sueldo_diario: administracion?.sueldo_diario_nominal_asignado,
      sueldo_mensual: administracion?.sueldo_mensual_nominal_asignado,
    });
  };

  const onClickEdit = async (idFromSaved = null) => {
    try {
      setLoading(true);

      // usar el ID recibido o el primero seleccionado
      const key = idFromSaved ?? selectedRowKeys[0];
      if (!key) {
        message.warn('No se Encontro el ID');
        setLoading(false);
        return null;
      }

      // 1 sola llamada — endpoint optimizado ya une empleado, DOE, plaza, puesto y área
      const lista = await getLiquidacionesEmpleados({ id: key });
      const reg = Array.isArray(lista) ? lista[0] : lista;
      if (!reg) {
        setLoading(false);
        message.warn('No se Encontro el Registro');
        return null;
      }

      // 2. Banderas de liquidación
      if (!Array.isArray(liquidaciones) || liquidaciones?.length === 0) {
        message.warn('Catálogo de liquidaciones no disponible');
        setLoading(false);
        return null;
      }
      const liq = liquidaciones?.find((l) => l?.id === reg?.liquidacion_id);
      setLiquidacionAplicaFiniquito(!!liq?.aplica_finiquito);
      setLiquidacionAplicaIndemnizacion(!!liq?.aplica_indemnizacion);
      setLiquidacionDescuentoEnable(true);
      setLiquidacionDeduccionEnable(true);
      setLiquidacionAnexoEnable(true);

      // 3. Fechas (vienen del endpoint)
      const formatFechaIngreso = reg?.fecha_de_alta ? moment(reg.fecha_de_alta).format('DD/MM/YYYY') : '';
      const formatFechaReingreso = reg?.fecha_de_reingreso ? moment(reg.fecha_de_reingreso).format('DD/MM/YYYY') : '';

      // 4. Tipo de Nómina Empleado — guardar en estado para cascada Periodo Fiscal → Periodo de Nómina
      const tipoNomina = reg?.tipo_de_nomina_empleado_id;
      setTipoNominaEmpleadoId(tipoNomina);

      // 5. Filtrado de periodos de nómina
      const periodoFiscal = reg?.periodo_fiscal_id;
      const _periodosNominas = periodosDeNominas?.filter(
        (e) => e?.tipo_de_nomina_empleado === tipoNomina && e?.periodo_fiscal === periodoFiscal,
      );
      const _periodosDetallesFiltered = periodosDeNominaDetalles?.filter(
        (e) => _periodosNominas?.some((x) => x.id === e.periodo_de_nomina),
      );
      setPeriodosDetallesFiltered(_periodosDetallesFiltered);

      // 6. Rellenar formulario
      form.resetFields();
      setLiquidacionEmpleado(reg?.id);
      setImporteNeto(reg?.importe_neto);
      // Sincroniza la selección con el registro realmente abierto (no solo con lo que
      // haya quedado en selectedRowKeys): el doble clic en una fila dispara su propio
      // onClick (que alterna la selección) justo antes del onDoubleClick, así que al
      // llegar aquí selectedRowKeys puede haber quedado vacío aunque sí se esté editando
      // un registro — eso rompía el título "Editar" y ocultaba los tabs Finiquito/Anexos.
      setSelectedRowKeys([reg.id]);
      setSelectedData([reg]);
      fetchAdministracionesDePlaza(reg?.empleado_id);

      form.setFieldsValue({
        empleado: reg?.empleado_id,
        tipo_empleado: reg?.tipo_empleado_descripcion,
        tipo_nomina_empleado: tiposDeNominaEmpleado.find((t) => t.id === tipoNomina)?.descripcion || '',
        puesto: reg?.puesto_clave_y_descripcion,
        unidad_responsable: reg?.directorio_de_area_clave_y_nombre,
        plaza: reg?.plaza_clave_y_descripcion,
        // El endpoint de lista (vista-optimizada, SQL crudo) expone la columna tal
        // cual está en la tabla ("administracion_de_plaza_id"), no el nombre que usa
        // el serializer del ViewSet real ("administracion_de_plaza") — a diferencia
        // de fecha_de_baja/plaza_clave_y_descripcion, que sí comparten nombre en ambos.
        administracion_de_plaza: reg?.administracion_de_plaza_id,
        fecha_ingreso: formatFechaIngreso,
        fecha_de_baja: reg?.fecha_de_baja ? moment(reg.fecha_de_baja) : null,
        fecha_reingreso: formatFechaReingreso,
        sueldo_diario: reg?.sueldo_diario,
        sueldo_mensual: reg?.sueldo_mensual,
        antiguedad: reg?.antiguedad_texto,
        liquidacion: reg?.liquidacion_id,
        periodo_fiscal: reg?.periodo_fiscal_id,
        periodo_de_nomina_detalle: reg?.periodo_de_nomina_detalle_id,
        dias_trabajados: reg?.dias_trabajados,
        dias_laborados_aguinaldo: reg?.dias_laborados_aguinaldo,
        dias_para_prima_vacacional: reg?.dias_para_prima_vacacional,
        sueldo_promedio: reg?.sueldo_promedio_aguinaldo,
        isr_de_sueldo_nominal: reg?.isr_de_sueldo_nominal,
        estados_globales: reg?.estados_globales_id,
        observaciones: reg?.observaciones,
        tipo_de_contratacion: reg?.tipo_de_contratacion_descripcion || '',
        motivo_baja: reg?.motivo_baja_concepto || '',
      });

      // 6. Mostrar formulario
      setVisible(true);
      return true;
    } catch (error) {
      onError(
        error,
        setLoading,
        formInstances,
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  const onCancelModal = () => {
    setVisiblePeriodo(false);
    formModal.resetFields();
  };
  const onFinishModal = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await formModal.validateFields();
      const [key] = selectedRowKeys;

      const _liquidacionesEmpleado = selectedData[0];
      const values = {
        ...formModal.getFieldsValue(),
        empleado: _liquidacionesEmpleado?.empleado_id,
      };

      // const values = selectedData?.map((liquidacion) => ({
      //   ...formModal.getFieldsValue(),
      //   empleado: liquidacion?.empleado_id,
      // }));

      // Crear o actualizar según si hay clave seleccionada
      const saved = await patchLiquidacionEmpleado(key, values);

      if (saved) {
        // siempre cerrar el modal al guardar
        onCancelModal();

        // refrescar la tabla
        await fetchData();
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = {
        ...form.getFieldsValue(),
        // empleado: selectedEmpleadoSearch?.id,
        importe_neto: 0,
      };

      const [key] = selectedRowKeys;

      // Crear o actualizar según si hay clave seleccionada
      const saved = await (
        key
          ? patchLiquidacionEmpleado(key, values)
          : postLiquidacionEmpleado(values)
      );

      if (saved) {
        if (key) {
          // Edición: "Guardar y Continuar" refresca la tabla y recarga los datos
          // del registro (puede traer campos recalculados/derivados), pero sin
          // cerrar el formulario — el usuario sigue editando/revisando Finiquito.
          await fetchData();
          await onClickEdit(key);
        } else {
          // Nuevo: refrescar tabla y recargar formulario con el registro creado
          const newId = saved?.id;
          await fetchData();
          if (newId) {
            // Primero cargar datos del registro (setea liquidacionEmpleado y flags de tabs)
            await onClickEdit(newId);
            // Luego activar selectedRowKeys para que los tabs se rendericen con datos ya correctos
            setSelectedRowKeys([newId]);
            setSelectedData([saved]);
          }
        }
      }

      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const onClickRecalcular = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        return;
      }
      const recalculado = await recalcularLiquidacionEmpleado(key);
      if (recalculado) {
        await fetchData();
        // Recarga el registro (snapshot, importes y Finiquito/Indemnización
        // recalculados) sin cerrar el formulario.
        await onClickEdit(key);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteLiquidacionEmpleado(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = async (record) => {
    /** es para cuando era solo un registro */
    // setPeriodo({
    //   periodoId: record.periodo,
    //   periodoDetalle: record.periodo_detalle,
    // });
    if (selectedRowKeys.includes(record.id)) {
      setSelectedRowKeys(selectedRowKeys.filter((id) => id !== record.id));
      setSelectedData(selectedData.filter((row) => row.id !== record.id));
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
      setSelectedData([...selectedData, record]);
    }
  };

  const handleSelectAll = (selected, selectedRows, changeRows) => {
    if (selected) {
      // Si el usuario marca el check de "Todos":
      // Mapeamos DIRECTAMENTE sobre 'empleadosFiltered' para obtener todos los IDs,
      // ignorando la paginación actual.
      const allIds = data.map((row) => row.id);
      setSelectedRowKeys(allIds);
      setSelectedData(data);
    } else {
      // Si el usuario desmarca el check, limpiamos la selección
      setSelectedRowKeys([]);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, rows) => {
      setSelectedRowKeys(keys);
      setSelectedData(rows);
    },
    onSelectAll: handleSelectAll,
    type: 'checkbox',
  };

  const onClickAdd = async () => {
    setLoading(true);

    setSelectedRowKeys([]);
    setSelectedEmpleadoSearch();
    setLiquidacionAplicaFiniquito(false);
    setLiquidacionAplicaIndemnizacion(false);
    setLiquidacionDescuentoEnable(false);
    setLiquidacionDeduccionEnable(false);
    setLiquidacionAnexoEnable(false);
    setImporteNeto();
    setAdministracionesDePlaza([]);
    setVisible(false);
    setVisibleSearch(false);
    form.resetFields();
    setVisible(true);

    setLoading(false);
  };

  const onClickDelete = () => {
    const empleadoId = parseInt(form.getFieldValue('empleado'), 10);
    const empleado = data.find((item) => item.empleado_id === empleadoId);
    setLiquidacionEmpleadoDelete(empleado?.numero_y_nombre_completo || 'Empleado desconocido');
    setVisibleAlert(true);
  };

  // const onChangeEmpleadoPorId = async (empleadoId) => {
  //   if (!empleadoId) return;

  //   setLoading(true);
  //   try {
  //     const empleado = await getEmpleado(empleadoId);
  //     const datoOp = await getDatoOperacionalPorEmpleado(empleadoId);
  //     const plaza = await getPlazavistaOptimized(datoOp?.plaza);

  //     if (!empleado || !datoOp || !plaza) {
  //       return;
  //     }

  //     // aquí traemos el puesto
  //     let puesto = null;
  //     if (plaza?.puesto_id) {
  //       puesto = await getPuesto(plaza?.puesto_id);
  //     }

  //     setSelectedEmpleadoSearch(empleado);
  //     setLiquidacionEmpleado(empleado.id);

  //     const fechaIngreso = datoOp?.fecha_de_alta;
  //     const fechaBaja = datoOp?.fecha_de_baja;
  //     const antiguedad = calcularAntiguedad(moment(fechaIngreso));

  //     form.setFieldsValue({
  //       empleado: `${empleado.numero_de_empleado} - ${empleado.nombre} ${empleado.apellido_paterno} ${empleado.apellido_materno}`,
  //       tipo_empleado: plaza?.tipo_de_empleado,
  //       puesto: puesto ? `${puesto.clave} - ${puesto.descripcion}` : plaza?.puesto,
  //       unidad_responsable: plaza?.directorio_area,
  //       plaza: plaza?.clave_y_descripcion,
  //       fecha_ingreso: fechaIngreso ? moment(fechaIngreso).format('DD/MM/YYYY') : '',
  //       fecha_baja: fechaBaja ? moment(fechaBaja).format('DD/MM/YYYY') : '',
  //       sueldo_diario: datoOp?.sueldo_diario,
  //       sueldo_mensual: datoOp?.sueldo_mensual,
  //       salario_minimo: datoOp?.zona_de_salario_minimo || 'N/A',
  //       antiguedad,
  //     });
  //   } catch (error) {
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const filterPeriodos = (periodo_fiscal) => {
    if (!tipoNominaEmpleadoId) {
      message.warn('Seleccione un empleado primero');
      return;
    }
    const _periodosNominas = periodosDeNominas.filter(
      (e) => e.tipo_de_nomina_empleado === tipoNominaEmpleadoId
        && e.periodo_fiscal === periodo_fiscal,
    );
    const _periodosDetallesFiltered = periodosDeNominaDetalles.filter(
      (e) => _periodosNominas.some((x) => x.id === e.periodo_de_nomina),
    );
    setPeriodosDetallesFiltered(_periodosDetallesFiltered);
  };

  // const resetEmpleadoSeleccionado = () => {
  //   setSelectedEmpleadoSearch(undefined);
  //   setLiquidacionEmpleado(undefined);
  //   form.resetFields([
  //     'empleado',
  //     'tipo_empleado',
  //     'puesto',
  //     'unidad_responsable',
  //     'plaza',
  //     'sueldo_mensual',
  //     'sueldo_diario',
  //     'fecha_ingreso',
  //     'fecha_baja',
  //     'salario_minimo',
  //     'antiguedad',
  //     'liquidacion',
  //     'periodo_de_nomina_detalle',
  //     'isr_de_sueldo_nominal',
  //     'importe_neto',
  //     'observaciones',
  //   ]);
  // };
  // const validateInput = () => {
  //   resetEmpleadoSeleccionado(); // Limpia todo
  //   setVisibleSearch(true); // Abre el modal de búsqueda
  // };

  // const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
  //   setLoading(true);
  //   if (empId) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&numero_de_empleado=${empId};`;
  //   }
  //   if (nombreEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&nombre=${nombreEmp};`;
  //   }
  //   if (apPatEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&apellido_paterno=${apPatEmp};`;
  //   }
  //   if (apMatEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&apellido_materno=${apMatEmp};`;
  //   }
  //   if (tipoNominaEmpleado) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
  //   }
  //   setBaseURIPagination(baseURIDatosOpPaginado);
  //   const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURIDatosOpPaginado);
  //   setDataSearch(_empleados);
  //   return setLoading(false);
  // };

  // const columnsEmpleado = [
  //   {
  //     titleText: 'No. de Empleado',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 200,
  //     render: (empObject) => empObject?.numero_de_empleado,
  //   },
  //   {
  //     titleText: 'Nombre',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.nombre,
  //   },
  //   {
  //     titleText: 'Apellido Paterno',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.apellido_paterno,
  //   },
  //   {
  //     titleText: 'Apellido Materno',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.apellido_materno,
  //   },
  //   {
  //     titleText: 'Puesto',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 300,
  //     render: (empObject) => {
  //       const adminPlazaEmp = administracionPlazas?.find((admP) => admP?.empleado === empObject?.id);
  //       const plazaEmp = plazas?.find((pl) => pl?.id === adminPlazaEmp?.plaza);
  //       const puestoEmp = puestos?.find((p) => p?.id === plazaEmp?.puesto);
  //       return `${puestoEmp?.descripcion || ''}`;
  //     },
  //   },
  //   {
  //     titleText: 'Tipo de Nómina Empleado',
  //     dataIndex: 'tipo_de_nomina_empleado',
  //     key: 'tipo_de_nomina_empleado',
  //     width: 250,
  //     render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
  //   },
  // ];

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una Liquidacion de Empleados ya autorizado');
        return;
      }
      const _liquidacionesEmpleado = selectedData[0];
      const saved = await patchLiquidacionEmpleado(key, {
        empleado: _liquidacionesEmpleado?.empleado_id,
        estados_globales: ESTATUS_AUTORIZADO,
      });
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmCancelar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const _liquidacionesEmpleado = selectedData[0];
      const saved = await patchLiquidacionEmpleado(key, {
        empleado: _liquidacionesEmpleado?.empleado_id,
        estados_globales: ESTATUS_CANCELADO,
      });
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmReactivar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const _liquidacionesEmpleado = selectedData[0];
      const saved = await patchLiquidacionEmpleado(key, {
        empleado: _liquidacionesEmpleado?.empleado_id,
        estados_globales: ESTATUS_ACTIVO,
      });
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const updateFormValues = async (val) => {
    setAdministracionesDePlaza([]);
    form.resetFields(['administracion_de_plaza']);
    fetchAdministracionesDePlaza(val);
    if (val) {
      try {
        const [_datosOperacionales] = await getDatoOperacionalesDeEmpleados({ empleado: val });

        // Buscar plaza asociada
        const _plaza = plazas?.find((p) => p.id === _datosOperacionales?.plaza);

        // 6. Fechas y antigüedad
        const fechaIngreso = _datosOperacionales?.fecha_de_alta;
        const fechaBaja = _datosOperacionales?.fecha_de_baja;
        const fechaReingreso = _datosOperacionales?.fecha_de_reingreso;
        const formatFechaIngreso = fechaIngreso ? moment(fechaIngreso).format('DD/MM/YYYY') : '';
        const formatFechaReingreso = fechaReingreso ? moment(fechaReingreso).format('DD/MM/YYYY') : '';
        const antiguedad = _datosOperacionales?.antiguedad_texto || calcularAntiguedad(moment(fechaIngreso));

        // 7. Tipo de Nómina Empleado — guardar en estado para cascada Periodo Fiscal → Periodo de Nómina
        const tipoNomina = _datosOperacionales?.tipo_de_nomina_empleado;
        setTipoNominaEmpleadoId(tipoNomina);

        // 8. Filtrado de periodos de nómina
        const periodoFiscal = periodoFiscalSelected?.id; // obtengo el del sistema por default
        const _periodosNominas = periodosDeNominas.filter(
          (e) => e.tipo_de_nomina_empleado === tipoNomina && e.periodo_fiscal === periodoFiscal,
        );
        const _periodosDetallesFiltered = periodosDeNominaDetalles.filter(
          (e) => _periodosNominas.some((x) => x.id === e.periodo_de_nomina),
        );
        setPeriodosDetallesFiltered(_periodosDetallesFiltered);

        form.resetFields();

        form.setFieldsValue({
          empleado: val,
          tipo_empleado: _plaza?.tipo_de_empleado,
          tipo_nomina_empleado: tiposDeNominaEmpleado.find((t) => t.id === tipoNomina)?.descripcion || '',
          puesto: _plaza?.puesto_clave_y_descripcion,
          unidad_responsable: _plaza?.directorio_area_clave_y_nombre,
          plaza: _plaza?.clave_y_descripcion,
          fecha_ingreso: formatFechaIngreso,
          fecha_de_baja: fechaBaja ? moment(fechaBaja) : null,
          fecha_reingreso: formatFechaReingreso,
          sueldo_diario: _datosOperacionales?.sueldo_diario,
          sueldo_mensual: _datosOperacionales?.sueldo_mensual,
          salario_minimo: _datosOperacionales?.zona_de_salario_minimo || 'N/A',
          antiguedad,
        });

        // Actualizar estados locales
      } catch (error) {
        onError(error);
      }
    } else {
      form.resetFields(['empleado', 'plaza', 'puesto', 'directorio_de_areas']);
    }
  };

  const columns = [
    {
      titleText: 'No. Empleado',
      dataIndex: 'empleado_id',
      key: 'empleado_id',
      width: 150,
    },
    {
      titleText: 'No. y Nombre de Empleado',
      dataIndex: 'numero_y_nombre_completo',
      key: 'numero_y_nombre_completo',
      width: 300,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'tipo_empleado_descripcion',
      key: 'tipo_empleado_descripcion',
      width: 300,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 300,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 300,
    },
    {
      titleText: 'No. de Plaza',
      dataIndex: 'plaza_no',
      key: 'plaza_no',
      width: 300,
    },
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 300,
    },
    {
      titleText: 'Fecha de Alta',
      dataIndex: 'fecha_de_alta',
      key: 'fecha_de_alta',
      width: 300,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Fecha de Baja',
      dataIndex: 'fecha_de_baja',
      key: 'fecha_de_baja',
      width: 300,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Periodo Fiscal',
      dataIndex: 'periodo_fiscal_id',
      key: 'periodo_fiscal_id',
      width: 200,
      render: (val) => periodosFiscales.find((periodo) => periodo.id === val)?.periodo,
    },
    {
      titleText: 'Periodo de Nómina',
      dataIndex: 'periodo_de_nomina_detalle_id',
      key: 'periodo_de_nomina_detalle_id',
      width: 300,
      render: (val) => {
        const periodo = periodosDeNominaDetalles.find((p) => p.id === val);
        return periodo ? `${periodo?.numero_de_nomina} (${periodo?.fecha_inicial} al ${periodo?.fecha_final})` : '';
      },
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado_id',
      key: 'tipo_de_nomina_empleado_id',
      width: 300,
      render: (val) => tiposDeNominaEmpleado.find((tipo) => tipo.id === val)?.descripcion,
    },
    {
      titleText: 'Tipo de Contratación',
      dataIndex: 'tipo_de_contratacion_descripcion',
      key: 'tipo_de_contratacion_descripcion',
      width: 300,
    },
    {
      titleText: 'Antigüedad',
      dataIndex: 'antiguedad_texto',
      key: 'antiguedad_texto',
      width: 300,
    },
    {
      titleText: 'Motivo de Baja',
      dataIndex: 'motivo_baja_concepto',
      key: 'motivo_baja_concepto',
      width: 300,
    },
    {
      titleText: 'Importe de Finiquito',
      dataIndex: 'importe_percepciones_finiquito',
      key: 'importe_percepciones_finiquito',
      width: 300,
      align: 'right',
      render: (val) => currencyFormatter(Number(val) || 0),
    },
    {
      titleText: 'Importe de Indemnización',
      dataIndex: 'importe_percepciones_indemnizacion',
      key: 'importe_percepciones_indemnizacion',
      width: 300,
      align: 'right',
      render: (val) => currencyFormatter(Number(val) || 0),
    },
    {
      titleText: 'Importe de Descuentos',
      dataIndex: 'importe_descuentos',
      key: 'importe_descuentos',
      width: 300,
      align: 'right',
      render: (val) => currencyFormatter(Number(val) || 0),
    },
    {
      titleText: 'Importe de Deducciones',
      dataIndex: 'importe_deducciones',
      key: 'importe_deducciones',
      width: 300,
      align: 'right',
      render: (val) => currencyFormatter(Number(val) || 0),
    },
    {
      titleText: 'Importe Neto',
      dataIndex: 'importe_neto',
      key: 'importe_neto',
      width: 300,
      align: 'right',
      render: (val) => currencyFormatter(Number(val) || 0),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales_descripcion',
      key: 'estados_globales_descripcion',
      width: 300,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
  };

  // La Administración de Plaza seleccionada (si la hay) determina si Fecha de Baja
  // debe quedar editable: una Administración Vigente (Autorizada) no tiene fecha_baja
  // propia para auto-llenarlo, así que el usuario debe capturarla a mano para poder
  // calcular la Liquidación (ver validate() en LiquidacionEmpleadoModelSerializer, que
  // exige Fecha de Baja en este caso).
  const administracionDePlazaSeleccionadaId = form.getFieldValue('administracion_de_plaza');
  const administracionDePlazaSeleccionada = administracionesDePlaza.find(
    (a) => a.id === administracionDePlazaSeleccionadaId,
  );
  const fechaDeBajaEditable = administracionesDePlaza.length === 0
    || (!!administracionDePlazaSeleccionada && !administracionDePlazaSeleccionada.fecha_baja);

  const onClickExportarExcel = () => {
    setShowExportador(true);
  };

  const menuExportar = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Excel',
          text: 'Excel',
          icon: <FileExcelOutlined />,
          onClick: () => onClickExportarExcel(),
          disabledBySelection: false,
        },
        {
          key: 2,
          label: 'PDF',
          text: 'PDF',
          icon: <FilePdfOutlined />,
          disabledBySelection: false,
        },
        {
          key: 'reporte_liquidaciones',
          label: 'Reporte de Liquidaciones',
          text: 'Reporte de Liquidaciones',
          icon: <FileExcelOutlined />,
          onClick: () => setShowReporteLiquidaciones(true),
          disabledBySelection: false,
        },
      ]}
    />
  );

  const accionPeriodoPago = {
    text: 'Periodo de Pago',
    icon: <AccountBookOutlined />,
    onClick: () => setVisiblePeriodo(true),
    disabledBySelection: true,
  };

  const accionAutorizar = {
    onClick: () => setVisibleAutorizar(true),
    permission: { model: 'liquidacionempleado', action: 'autorizar' },
    text: 'Autorizar',
    icon: <CheckCircleOutlined />,
    disabledBySelection: true,
    disabled: selectedData?.length !== 1 || selectedData[0]?.estados_globales_id !== ESTATUS_ACTIVO,
    className: 'success',
  };

  const accionCancelar = {
    onClick: () => setVisibleCancelar(true),
    permission: { model: 'liquidacionempleado', action: 'cancelar' },
    text: 'Cancelar',
    icon: <CloseCircleOutlined />,
    disabledBySelection: true,
    disabled: selectedData?.length !== 1 || selectedData[0]?.estados_globales_id === ESTATUS_CANCELADO,
    className: 'cancel',
  };

  const accionReactivar = {
    onClick: () => setVisibleReactivar(true),
    permission: { model: 'liquidacionempleado', action: 'reactivar' },
    text: 'Reactivar',
    icon: <RedoOutlined />,
    disabledBySelection: true,
    disabled: selectedData?.length !== 1 || selectedData[0]?.estados_globales_id === ESTATUS_ACTIVO,
    className: 'success',
  };

  const renderTablaLiquidaciones = (customActions, disableDeleteTab = selectedData?.length !== 1) => (
    <Table
      data={data}
      cols={columns}
      allowSearch
      rowSelection={rowSelection}
      handleOnRowClick={handleOnRowClick}
      customExportMenu={menuExportar}
      allowCustomExport
      controls={{
        onClickAdd,
        onClickEdit: (record) => onClickEdit(record?.id || null),
        onClickDelete,
      }}
      customActions={customActions}
      disableEdit={selectedData?.length !== 1}
      disableDelete={disableDeleteTab}
      permission={permission}
    />
  );

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Tabs
            activeKey={tabListaActiva}
            onChange={onChangeTabLista}
            items={[
              {
                key: 'todas',
                label: 'Todas',
                children: renderTablaLiquidaciones(
                  [accionPeriodoPago, accionAutorizar, accionCancelar, accionReactivar],
                ),
              },
              {
                key: 'activas',
                label: 'Activas',
                children: renderTablaLiquidaciones([accionPeriodoPago, accionAutorizar, accionCancelar]),
              },
              {
                key: 'autorizadas',
                label: 'Autorizadas',
                children: renderTablaLiquidaciones([accionPeriodoPago, accionCancelar, accionReactivar], true),
              },
              {
                key: 'canceladas',
                label: 'Canceladas',
                children: renderTablaLiquidaciones([accionReactivar], true),
              },
            ]}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Liquidación`}
            extra={(
              <FormSubmitControls
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
                customActions={selectedRowKeys.length ? [{
                  onClick: onClickRecalcular,
                  icon: <SyncOutlined />,
                  text: 'Recalcular',
                  disabled: loading || !hasActionPermission('liquidacionempleado', 'recalcular'),
                }] : []}
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
            >
              <Row gutter={10}>
                {/* <Col xs={24} sm={24} md={8}>
                  <Row align="middle">
                     <Col xs={24} sm={24} md={24}>
                      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <Form.Item
                          label="No. y Nombre del Empleado"
                          name="empleado"
                          rules={rules.required}
                          hasFeedback
                        >
                          <Input
                            allowClear
                            disabled={selectedRowKeys?.length}
                          />
                        </Form.Item>
                        <Button
                          loading={loading}
                          onClick={validateInput}
                          icon={<SearchOutlined />}
                          style={{
                            width: '2.7rem',
                            marginTop: '-2px',
                          }}
                          disabled={selectedRowKeys?.length}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col> */}
                {/* {selectedEmpleadoSearch
                  ? (
                    form.setFieldsValue({
                      empleado: `${selectedEmpleadoSearch?.numero_de_empleado || ''} - ${selectedEmpleadoSearch?.nombre || ''} ${selectedEmpleadoSearch?.apellido_paterno || ''} ${selectedEmpleadoSearch?.apellido_materno || ''}`,
                    })
                  ) : null} */}
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="empleado"
                    label="No. y Nombre de Empleado"
                    hasFeedback
                    rules={rules.required}
                  >
                    <Select
                      dataSource={empleados}
                      render={(emp) => emp?.numero_y_nombre_completo}
                      onChange={async (val) => {
                        if (!val) {
                          return;
                        }
                        setLoading(true);
                        updateFormValues(val);
                        setLoading(false);
                      }}
                      allowClear
                      disabled={selectedRowKeys?.length}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_empleado"
                    label="Tipo de Empleado"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_nomina_empleado"
                    label="Tipo de Nómina Empleado"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="puesto"
                    label="Puesto"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_de_contratacion"
                    label="Tipo de Contratación"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="motivo_baja"
                    label="Motivo de Baja"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="administracion_de_plaza"
                    label="Administración de Plaza"
                    rules={rules.required}
                    hasFeedback
                    tooltip="Elige la Asignación (vigente) o Desasignación (histórica) de Plaza que corresponde a esta Liquidación. Puesto, Tipo de Contratación, Plaza, sueldos, etc. se congelan en la Liquidación tal como se capturaron en ese registro."
                  >
                    <Select
                      allowClear
                      dataSource={administracionesDePlaza}
                      render={(a) => {
                        // El estatus mostrado se basa en estado_global_id (4=Autorizada/Vigente,
                        // 3=Inactiva/Histórica), no en si fecha_baja está capturada: una
                        // Desasignación histórica puede no traer fecha_baja propia, y una
                        // Asignación vigente nunca debería mostrarse como "Histórica".
                        let estatus = '';
                        if (a?.estado_global_id === ESTATUS_AUTORIZADO) {
                          estatus = 'Vigente';
                        } else if (a?.estado_global_id === ESTATUS_INACTIVO) {
                          estatus = a?.fecha_baja
                            ? `Histórica - Baja: ${moment(a.fecha_baja).format('DD/MM/YYYY')}`
                            : 'Histórica';
                        }
                        return `${a?.plaza_clave_y_descripcion || ''}${estatus ? ` - ${estatus}` : ''}`;
                      }}
                      onChange={(val) => {
                        if (!val) {
                          return;
                        }
                        aplicarAdministracionDePlaza(val);
                      }}
                      disabled={!form.getFieldValue('empleado') || !administracionesDePlaza.length}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="unidad_responsable"
                    label="Área"
                  >
                    <TreeSelect
                      disabled
                      showSearch
                      treeData={areas}
                      treeNodeFilterProp="title"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="plaza"
                    label="Plaza"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    name="sueldo_diario"
                    label="Sueldo Diario del Empleado"
                    disabled
                  />
                </Col>
              </Row>
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    name="sueldo_mensual"
                    label="Sueldo Mensual del Empleado"
                    disabled
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_ingreso"
                    label="Fecha de Alta"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_reingreso"
                    label="Fecha de Reingreso"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_de_baja"
                    label="Fecha de Baja"
                    rules={fechaDeBajaEditable ? rules.required : undefined}
                    hasFeedback={fechaDeBajaEditable}
                    tooltip={fechaDeBajaEditable
                      ? 'La Administración de Plaza elegida está Vigente (o el empleado no '
                        + 'tiene ninguna) y no trae su propia Fecha de Baja. Captúrala aquí '
                        + 'manualmente — es obligatoria para poder calcular y guardar esta '
                        + 'Liquidación.'
                      : undefined}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      format="DD/MM/YYYY"
                      disabled={!fechaDeBajaEditable}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    name="salario_minimo"
                    label="Salario Mínimo General Diario"
                    disabled
                    hasFeedback={false}
                  />
                </Col> */}
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="antiguedad"
                    label="Antigüedad"
                  >
                    <Select
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="liquidacion"
                    label="Clave de Liquidación"
                    rules={rules.required}
                  >
                    <Select
                      allowClear
                      dataSource={liquidaciones}
                      onChange={(val) => {
                        const liq = liquidaciones.find((li) => li.id === val);
                        setLiquidacionAplicaFiniquito(!!liq?.aplica_finiquito);
                        setLiquidacionAplicaIndemnizacion(!!liq?.aplica_indemnizacion);
                      }}
                      disabled={selectedRowKeys.length}
                      render={
                        (val) => `${val.clave} - ${motivosLiquidaciones.find((motivo) => motivo?.id === val?.motivo_de_liquidacion)?.motivo}`
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="dias_trabajados"
                    label="Días Laborados"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="dias_laborados_aguinaldo"
                    label="Días Para Aguinaldo"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="dias_para_prima_vacacional"
                    label="Días para Prima Vacacional"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    name="sueldo_promedio"
                    label="Sueldo Promedio Diario"
                    disabled
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="periodo_fiscal"
                    label="Periodo Fiscal"
                    rules={rules.estatus}
                    hasFeedback
                  >
                    <Select
                      dataSource={periodosFiscales}
                      disabled={!tipoNominaEmpleadoId || (!!selectedRowKeys.length && selectedData[0]?.estados_globales_id !== ESTATUS_ACTIVO)}
                      onChange={async (val) => {
                        form.resetFields(['periodo_de_nomina_detalle', 'dias_calculados']);
                        await filterPeriodos(val);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="periodo_de_nomina_detalle"
                    label="Periodo de Nómina"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      dataSource={periodosDetallesFiltered}
                      disabled={!tipoNominaEmpleadoId || (!!selectedRowKeys.length && selectedData[0]?.estados_globales_id !== ESTATUS_ACTIVO)}
                      render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <PercentageInput
                    name="isr_de_sueldo_nominal"
                    label="% de ISR de Sueldo Nominal Mensual"
                    disabled
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    name="importe_neto"
                    label="Importe de Liquidación"
                    val={importeNeto}
                    disabled
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.estatus}
                    hasFeedback
                    initialValue={1}
                  >
                    <Select
                      dataSource={estados}
                      disabled={selectedRowKeys.length <= 0}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={10}>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    name="observaciones"
                    label="Observaciones"
                  >
                    <TextArea
                      rows={3}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            {selectedRowKeys.length ? (
              <Tabs
                type="card"
                activeKey={currentTabKey}
                onChange={setCurrentTabKey}
              >
                {liquidacionAplicaFiniquito ? (
                  <TabPane
                    tab={(
                      <span>
                        Finiquito
                      </span>
                    )}
                    key="finiquito"
                    forceRender
                    disabled={!liquidacionAplicaFiniquito}
                  >
                    <LiquidacionesEmpleadosFiniquito
                      permission={getPermissionLiquidacionEmpleadoFiniquito}
                      liquidacionEmpleado={liquidacionEmpleado}
                      onClickEditEncabezado={onClickEdit}
                    />
                  </TabPane>
                ) : null}
                {liquidacionAplicaIndemnizacion ? (
                  <TabPane
                    tab={(
                      <span>
                        Indemnización
                      </span>
                    )}
                    key="indemnizacion"
                    forceRender
                    disabled={!liquidacionAplicaIndemnizacion}
                  >
                    <LiquidacionesEmpleadosIndemnizacion
                      permission={getPermissionLiquidacionEmpleadoIndemnizacion}
                      liquidacionEmpleado={liquidacionEmpleado}
                      onClickEditEncabezado={onClickEdit}
                    />
                  </TabPane>
                ) : null}
                {false && (
                // liquidacionDescuentoEnable ? (
                  <TabPane
                    tab={(
                      <span>
                        Descuentos
                      </span>
                    )}
                    key="descuento"
                    forceRender
                  >
                    <LiquidacionesEmpleadosDescuentos
                      permission={getPermissionLiquidacionEmpleadoDescuento}
                      liquidacionEmpleado={liquidacionEmpleado}
                      onClickEditEncabezado={onClickEdit}
                    />
                  </TabPane>
                )}
                {liquidacionDeduccionEnable ? (
                  <TabPane
                    tab={(
                      <span>
                        Deducciones
                      </span>
                    )}
                    key="deduccion"
                    forceRender
                  >
                    <LiquidacionesEmpleadosDeducciones
                      permission={getPermissionLiquidacionEmpleadoDeduccion}
                      liquidacionEmpleado={liquidacionEmpleado}
                      datosEncabezado={selectedData?.[0] || null}
                      onClickEditEncabezado={onClickEdit}
                    />
                  </TabPane>
                ) : null}
                {liquidacionAnexoEnable ? (
                  <TabPane
                    tab={(
                      <span>
                        Anexos
                      </span>
                    )}
                    key="anexo"
                    forceRender
                  >
                    <LiquidacionesEmpleadosAnexos
                      permission={getPermissionLiquidacionEmpleadoAnexo}
                      liquidacionEmpleado={liquidacionEmpleado}
                    />
                  </TabPane>
                ) : null}
              </Tabs>
            ) : null}
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={selectedData[0]?.numero_y_nombre_completo || ''}
          loading={loading}
        />
        <ExportadorExcelPersonalizado
          visible={showExportador}
          onCancel={() => setShowExportador(false)}
          data={data}
          fileName={`LiquidacionesDeEmpleados_${moment().format('YYYY-MM-DD')}`}
          sheetName="Liquidaciones"
        />
        <ModalPeriodoPagoLiquidacionEmpleado
          onUnasign={() => onFinishModal()}
          onCancel={() => onCancelModal()}
          open={visiblePeriodo}
          loading={loading}
          form={formModal}
          rules={rules}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle={`Autorizar ${selectedData[0]?.numero_y_nombre_completo}`}
          open={visibleAutorizar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmCancelar}
          ConfirmCancel
          onCancel={() => setVisibleCancelar(false)}
          contentTitle={`Cancelar ${selectedData[0]?.numero_y_nombre_completo}`}
          open={visibleCancelar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => setVisibleReactivar(false)}
          contentTitle={`Reactivar ${selectedData[0]?.numero_y_nombre_completo}`}
          open={visibleReactivar}
          loading={loading}
        />
        {/*
        <CustomSearch
          form={form}
          open={openSearch}
          setVisible={setVisibleSearch}
          modalTitle="Buscar Empleado"
          firstInputLabel="No. de Empleado"
          firstInputName="numero_de_empleado"
          secondInputLabel="Nombre del Empleado"
          secondInputName="nombre"
          searchInputLabel="Apellido Paterno"
          searchInputName="apellido_paterno"
          thirdInputLabel="Apellido Materno"
          thirdInputName="apellido_materno"
          firstSelectLabel="Tipo de Nómina Empleado"
          firstSelectName="tipo_de_nomina_empleado"
          firstSelectDataSource={tiposDeNominaEmpleado}
          inputsNeeded={3}
          selectsNeeded={1}
          paginatedTable
          modalWidth={1400}
          columns={columnsEmpleado}
          baseURI={baseURIPagination}
          setSelectedRow={(empleado) => {
            onChangeEmpleadoPorId(empleado.id);
          }}
          onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
          data={dataSearch}
          setData={setDataSearch}
          searchData={searchData}
          onChange={onChangeEmpleadoPorId}
        /> */}
        <ReporteRecurrenteModal
          open={showReporteLiquidaciones}
          onClose={() => setShowReporteLiquidaciones(false)}
          tipo="liquidaciones"
          titulo="Reporte de Liquidaciones"
          conceptoLabel="Motivos de Liquidación"
          conceptos={(motivosLiquidaciones || []).map((m) => ({ id: m.id, label: `${m.clave} - ${m.motivo}` }))}
          columnasConcepto={[
            { header: 'Motivo', key: 'concepto', width: 34 },
            { header: 'Tipo de Liquidación', key: 'tipo_de_liquidacion', width: 16 },
            { header: 'Folio Liquidación', key: 'folio_liquidacion', width: 16 },
            {
              header: 'Fecha de Baja', key: 'fecha_de_baja', width: 13, fecha: true,
            },
            {
              header: 'Finiquito', key: 'finiquito', width: 15, numFmt: FORMATO_MONEDA,
            },
            {
              header: 'Indemnización', key: 'indemnizacion', width: 15, numFmt: FORMATO_MONEDA,
            },
            {
              header: 'Percepciones', key: 'percepciones', width: 15, numFmt: FORMATO_MONEDA,
            },
            {
              header: 'Deducciones', key: 'deducciones', width: 15, numFmt: FORMATO_MONEDA,
            },
            {
              header: 'Descuentos', key: 'descuentos', width: 15, numFmt: FORMATO_MONEDA,
            },
            {
              header: 'Neto Pagado', key: 'importe', width: 15, numFmt: FORMATO_MONEDA,
            },
          ]}
          fileName="Reporte_Liquidaciones"
        />
      </Spin>
    </Row>
  );
};

export default LiquidacionesEmpleados;
